import React, { useEffect, useState } from "react";
import ClickNHold from "react-click-n-hold";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import { SendType } from "./Footer";
import TimeShower from "../../../components/TimeShower";
import BottomSheet from "../../../components/BottomSheet";
import { ReactComponent as SendVoiceIcon } from "../../../images/chat/send-voice-btn.svg";
import { ReactComponent as MicIcon } from "../../../images/chat/microphone.svg";
import { MessageType } from "../../../constant/Types";
import { message } from "antd";

const micorphoneAccessDeniedMsg =
  "لطفا اجازه دسترسی به میکروفون را به مرورگر خود بدهید";

window.voiceTimerInterval = "";

const VoiceInput = ({
  sendType,
  setSendType,
  sendMessage,
  voiceTime,
  setVoiceTime,
}) => {
  const [supported] = useState(true);
  const [voiceStart, setVoiceStart] = useState(0);
  const [voiceEnd, setVoiceEnd] = useState(0);
  const [isBlocked, setIsBlocked] = useState(true);

  // const [stream, setStream] = useState();
  const [mediaRecorder, setMediaRecorder] = useState();

  useEffect(() => {
    checkMicPermissions();
  }, []);

  useEffect(() => {
    if (voiceStart > 0 && sendType === SendType.voice.recoding) {
      window.voiceTimerInterval = setInterval(() => {
        let now = new Date().getTime();
        let voiceTime = (now - voiceStart) / 1000;
        window.voiceTime = voiceTime;
        setVoiceTime(voiceTime);
      }, 1000);
    }
  }, [sendType, setVoiceTime, voiceStart]);

  useEffect(() => {
    if (voiceEnd > 0) {
      clearInterval(window.voiceTimerInterval);
    }
  }, [voiceEnd]);

  const start = () => {
    if (!isBlocked) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          // setStream(stream);
          const recorder = new MediaRecorder(stream);
          setMediaRecorder(recorder);
          const audioChunks = [];
          recorder.ondataavailable = (e) => {
            audioChunks.push(e.data);
          };
          recorder.onstop = () => {
            const blob = new Blob(audioChunks, {
              type: "audio/mpeg; codecs=opus",
            });
            const reader = new FileReader();
            reader.readAsDataURL(blob);

            reader.onloadend = function () {
              const voiceData = reader.result.split(",");
              const duration = window.voiceTime
                ? window.voiceTime.toFixed()
                : 0;
              if (duration < 1) {
                cancelVoice();
                return;
              }
              if (voiceData[1]) {
                sendMessage(MessageType.client.voice, voiceData[1], {
                  duration,
                });
              }
              window.voiceTime = 0;
            };
          };
          recorder.start();
        })
        .catch((err) => {});
    } else {
      micPermissionGrant();
    }
  };

  const checkMicPermissions = () => {
    // only mozilla and chrome
    if (navigator && navigator.permissions && navigator.permissions.query) {
      navigator.permissions
        .query({ name: "microphone" })
        .then(function (result) {
          if (result.state === "granted") {
            setIsBlocked(false);
          } else if (result.state === "prompt" || result.state === "denied") {
            setIsBlocked(true);
          }
          result.onchange = function (event) {
            event.currentTarget && event.currentTarget.state === "granted"
              ? setIsBlocked(false)
              : setIsBlocked(true);
          };
        });
    }
  };

  const micPermissionGrant = () => {
    // all browsers
    const userMedia = navigator.mediaDevices.getUserMedia({ audio: true });
    if (isBlocked) {
      userMedia
        .then(function () {
          setIsBlocked(false);
        })
        .catch(function (err) {
          setIsBlocked(true);
        });
    }
  };

  const stop = () => {
    // if (stream) {
    //   stream.getTracks().forEach((track) => track.stop());
    // }
    if (mediaRecorder) {
      mediaRecorder.stop();
    }
    // setStream(undefined);
    setMediaRecorder(undefined);
  };

  function microphoneTouchStart() {
    if (!isBlocked) {
      setVoiceTime(1);
      clearInterval(window.voiceTimerInterval);
      setVoiceStart(new Date().getTime());
      setSendType(SendType.voice.recoding);
      start();
    } else {
      micPermissionGrant();
    }
  }

  function microphoneTouchHold() {
    !isBlocked && setSendType(SendType.voice.hold);
  }

  function microphoneTouchEnd() {
    let endTime = new Date().getTime();
    let time = endTime - voiceStart;
    if (time < 1000) {
      cancelVoice();
    }

    if (isBlocked) {
      message.config({
        maxCount: 1,
      });
      message.error(micorphoneAccessDeniedMsg);
    }
  }

  function cancelVoice(e) {
    if (mediaRecorder) mediaRecorder.onstop = undefined;
    setSendType(SendType.free);
    stop();
    setVoiceStart(0);
    setVoiceEnd(0);
    setVoiceTime(0);
  }

  function stopVoice() {
    setSendType(SendType.voice.send);
    setVoiceEnd(new Date().getTime());
    stop();
  }

  return supported ? (
    <>
      <ClickNHold
        time={1} // Time to keep pressing. Default is 2
        onStart={microphoneTouchStart}
        onClickNHold={microphoneTouchHold}
        onEnd={microphoneTouchEnd}
        className={"btn-mic-holder center-flex"}
      >
        <div className={`center-flex btn-mic`}>
          <MicIcon />
        </div>
      </ClickNHold>

      <BottomSheet
        isOpen={sendType === SendType.voice.hold}
        setCloseCustom={() => {
          setSendType(SendType.free);
          cancelVoice();
        }}
        classNames={"record-hold-bottom-sheet"}
        className={"record-hold-class-name"}
        viewerClassName={"react-hold-bottom-sheet-view"}
        style={{
          width: "99%",
        }}
      >
        <div
          className="record-hold unselectable"
          style={{ backgroundColor: "#fff" }}
        >
          <div className="cancel-voice unselectable" onClick={cancelVoice}>
            <DeleteOutlined />
          </div>
          <div className="voice-time unselectable">
            <TimeShower time={voiceTime ? voiceTime : 0} />
          </div>
          <div className="send-btn-holder unselectable">
            <div className="send-btn center-flex" onClick={stopVoice}>
              <SendVoiceIcon />
            </div>
          </div>
        </div>
      </BottomSheet>
    </>
  ) : (
    <div className={`center-flex btn-mic`}>
      <MicIcon />
    </div>
  );
};

export default VoiceInput;
